import React, { useState } from 'react';
import { education } from '../data/education';

export default function Education() {
  const [selectedEducation, setSelectedEducation] = useState(0);
  const currentEducation = education[selectedEducation];

  return (
    <section id="education" className="education-section">
      <div className="education-container fade-in-visible">
        <div className="education-title">
          <span className="text-content">Education</span>
        </div>

        <div className="education-content">
          <div className="institution-list">
            {education.map((edu, index) => (
              <button
                key={edu.id}
                className={`institution-tab ${index === selectedEducation ? 'active' : ''}`}
                onClick={() => setSelectedEducation(index)}
              >
                <div className="institution-name">{edu.institution}</div>
                <div className="institution-duration">{edu.duration}</div>
              </button>
            ))}
          </div>

          <div className="education-details">
            <div className="education-header">
              <h3 className="degree-title">
                {currentEducation.degree}
                <span className="institution-highlight">@ {currentEducation.institution}</span>
              </h3>
              <div className="education-meta">
                <span className="location">{currentEducation.location}</span>
                <span className="duration">{currentEducation.duration}</span>
              </div>
            </div>

            <div className="education-sections">
              {currentEducation.relevantCourses && (
                <div className="courses-section">
                  <h4>Relevant Coursework</h4>
                  <div className="courses-grid">
                    {currentEducation.relevantCourses.map((course, index) => (
                      <span key={index} className="course-tag">
                        {course}
                      </span>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
